import { render, staticRenderFns } from "./GroupBookingCreateReceipt.vue?vue&type=template&id=3bb759c6&"
import script from "./GroupBookingCreateReceipt.vue?vue&type=script&lang=js&"
export * from "./GroupBookingCreateReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports